<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Assurance" />
            <AssuRance />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import AssuRance from '../Services/Assurance'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'AssuRancePage',
    components: {
        NavBar,
        PageTitle,
        AssuRance,
        FooterComp,
    }
}
</script>